
import Modal from "react-modal";
import ReactModal from "react-modal";
import { useRecoilState } from "recoil";
import React, { useEffect, useState } from "react";
import { fontGreyColor, orangeColor2, primaryColor, repayCustomStyles, resendCustomStyles } from "../../../styles/theme";
import { isRepayPopupOpenState, isRequestConfirmOpenState, isRequestPopupOpenState, isRequestResultOpenState, isResendPopupOpenState, requestMemberCardState, resendLoadingState, resendReasonDetailState, resendReasonState, resendUserCardNumberState } from "../../../recoil/atoms";
import { BlueSpan, CloseButton, FlexBox, RedSpan, ModalBox, ModalContent, ModalHeader, ModalLi, ModalUl, PopupBtns, RoundButton, TextInput, TitleDiv, TextInputDiv, FlexInputBox } from "./style";
import closeIcon from "../../../assets/images/icon-close.svg";
import { paycardHypen } from "../../../util";
import { MoonLoader } from "react-spinners";
import { useDaumPostcodePopup } from "react-daum-postcode";
import { POSTCODE_URL } from "../../../constants";
import warningIcon from "../../../assets/images/icon-warning.svg";
import RequestConfirm from "./requestConfirm";
import RequestResult from "./requestResult";
import { ResponseModel, RESULT } from "../../../model/response";
import usePost from "../../../hooks/usePost";
import { requestMemberCardSelector } from "../../../recoil/variableAtom";
const parse = require("html-react-parser");

Modal.setAppElement("#root");


function RequestCardPopup() {
    const [isOpen, setIsOpen] = useRecoilState(isRequestPopupOpenState);
    const [isRequestConfirmOpen, setIsRequestConfirmOpen] = useRecoilState(isRequestConfirmOpenState);
    const [isRequestResultOpen, setIsRequestResultOpen] = useRecoilState(isRequestResultOpenState);
    const [rdnmadr, setRdnmadr] = useState('');
    const [adres, setAdres] = useState('');
    const [zipCode, setZipCode] = useState('');
    const [adresDetail, setAdresDetail] = useState('');
    const [data, setData] = useState<any>(null);
    const [result, setResult] = useState<string>('');
    const response: ResponseModel<any> = usePost({
        recoilSelector: requestMemberCardSelector,
        recoilState: requestMemberCardState,
        data: data,
    });

    function closeModal() {
        setIsOpen(false);
    }
    const openPostCode = useDaumPostcodePopup(POSTCODE_URL);

    const postCodeHandleClick = () => {
        openPostCode({ onComplete: postCodeHandleComplete });
    };
    const postCodeHandleComplete = (data: any) => {
        setRdnmadr(data.roadAddress);
        setAdres(data.jibunAddress === "" ? data.autoJibunAddress : data.jibunAddress);
        setZipCode(data.zonecode);
    };
    const handleSubmit = () => {
        if (rdnmadr === "" || adresDetail === "") {
            alert("주소를 입력해주세요.");
            return;
        }
        setIsRequestConfirmOpen(true);
    }
    const handleRequestConfirm = () => {
        setData({
            "adres": adres,
            "rdnmadr": rdnmadr,
            "adres_detail": adresDetail,
            "zip_code": zipCode,
        });
    }
    const handleRequestResult = () => {
        setIsOpen(false);
        setIsRequestConfirmOpen(false);
        setIsRequestResultOpen(false);
        window.location.reload();
    }

    useEffect(() => {
        if (response && response.result && data) {
            if (response.result === RESULT.OK) {
                setIsRequestResultOpen(true);
                setResult('발급 신청이 완료되었습니다. 관리자 확인 후 발급이 진행됩니다.');
            } else if (response.result === RESULT.FAIL) {
                setResult(response?.msg ?? '멤버십카드 발급 신청이 실패하였습니다.');
            }
        }
    }, [response, data]);

    ReactModal.defaultStyles.overlay!.backgroundColor = "rgba( 0, 0, 0, 0.5)";
    return (
        <>
            <Modal isOpen={isOpen} style={resendCustomStyles} contentLabel="EvPlug popup" shouldCloseOnOverlayClick={true}>
                <ModalBox width="540px">
                    <ModalHeader>
                        <TitleDiv>실물 멤버십카드 발급 신청</TitleDiv>
                        <CloseButton onClick={closeModal}><img src={closeIcon} alt="닫기" /></CloseButton>
                    </ModalHeader>
                    <ModalContent>
                        <div style={{ fontSize: '12px', color: orangeColor2 }}>온라인 카드만으로도 evPlug 충전소를 이용할 수 있습니다!</div>
                        <div style={{ fontSize: '12px', color: '#222222' }}>로밍충전소에서도 사용할 수 있는 멤버십 카드는 배송이 필요해요.</div>
                        <FlexInputBox style={{ marginTop: '18px', marginBottom: '18px' }}>
                            <TextInputDiv>배송지 주소<span style={{ color: 'red' }}>*</span></TextInputDiv>
                            <TextInput onClick={() => postCodeHandleClick()} onChange={(e) => setRdnmadr(e.target.value)} value={rdnmadr} placeholder="클릭하여 입력해주세요." />
                        </FlexInputBox>
                        <FlexInputBox style={{ marginBottom: '10px' }}>
                            <TextInputDiv>배송지 상세 주소<span style={{ color: 'red' }}>*</span></TextInputDiv>
                            <TextInput onChange={(e) => setAdresDetail(e.target.value)} value={adresDetail} placeholder="클릭하여 입력해주세요." />
                        </FlexInputBox>
                        <FlexBox style={{ marginBottom: '18px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px', fontWeight: '500', color: '#FF8116' }}>
                                <img src={warningIcon} alt="warning" style={{ marginRight: '10px' }} />
                                멤버십카드가 발송되는 주소입니다. 정확한 주소를 기입해 주시기 바랍니다.
                            </div>
                        </FlexBox>
                        <ModalUl>
                            <ModalLi>· 실물 멤버십 카드는 분실 또는 파손 시 재발급 받을 수 있으며, 비용이 발생합니다.</ModalLi>
                            <ModalLi>· 주소를 잘못 입력해 카드가 분실된 경우에도 재발급 가능하지만, 별도 비용이 부과됩니다.</ModalLi>
                            <ModalLi>· 새 멤버십 카드는 영업일 5일이내로 배송됩니다.</ModalLi>
                        </ModalUl>

                        <PopupBtns>
                            <RoundButton
                                fill={true}
                                width="300px"
                                onClick={() => { handleSubmit() }}
                                disabled={!rdnmadr || !adresDetail}
                            >
                                발급 신청하기
                            </RoundButton>
                        </PopupBtns>
                    </ModalContent>
                </ModalBox>
            </Modal >
            {
                isRequestConfirmOpen ? <RequestConfirm
                    onClick={() => {
                        handleRequestConfirm();
                    }}
                    closeBtnText="취소"
                    onClickBtnText="확인"
                    content={'실물 멤버십카드 발급을 신청하시겠습니까?'}
                /> : null
            }
            {
                isRequestResultOpen ? <RequestResult
                    onCloseClick={() => {
                        handleRequestResult();
                    }}
                    content={result}
                /> : null
            }
        </>
    );
}


export default RequestCardPopup;
